import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { dismissAppBootLoader, isHomePagePath } from '../../util/homePagePaths';

/**
 * Removes server-rendered boot/crawler HTML after React mounts.
 * On homepage routes, keeps the full-screen boot spinner until HomePage mounts
 * so users never see header + empty skeleton + footer.
 */
export function BootLoaderCleanup() {
    const { pathname } = useLocation();

    useEffect(() => {
        document.getElementById('seo-prerender')?.remove();

        if (!isHomePagePath(pathname)) {
            dismissAppBootLoader();
        }
    }, [pathname]);

    return null;
}
